import React, { useState, useEffect } from "react";
import Carousel from "react-bootstrap/Carousel";
import BootstrapSwitchButton from "bootstrap-switch-button-react";
import HSNModal from "./HSNModal";
import {
  Form,
  Table,
  Container,
  Row,
  Modal,
  Toast,
  Card,
  Button,
  Offcanvas,
  OverlayTrigger,
  Tooltip,
  Spinner,
} from "react-bootstrap";
import "../../assets/css/productDetail.css";
import "./detailNew.css";
import {
  approvedProducts,
  pdetailData,
  transferPriceHistory,
} from "../../seller-apis/apidataField";
import servicesApi from "../../seller-apis/servicesApi";
import api from "../../seller-apis/api";
import ConfirmationModal from "./ConfirmationModal";
import { useAlert } from "react-alert";
import "./detailNew.css";
import "../../assets/css/Offcanvas.css";
import "./popup.css";
import Confirmation from "./Confirmation";
import { useHistory, useLocation } from "react-router-dom";
import PopupProductReport from "./PopupProductReport";
import TPriceHistoryModal from "./TPriceHistoryModal";
import NewPriceOfferPopup2 from "./NewPriceOfferPopup2";
import ProductReviews from "./ProductReviews";
import WeightComponent from "./WeightComponent";
import { useDispatch, useSelector } from "react-redux";
import { resetPackages, setEditBtn, setInitialPackages, setReferencePackage } from "../../Actions/PackageWeight";
import { packagesCmtoFt, packagesFttoCm } from "../../utilities/conversion";
import { variables } from "../../Variables.json";
import { arePackagesEqual, checkIsPkgMediaNotPresent, isPackageLocked, sanitizePkgImages } from "../../utilities/packages";
import { formatedDate, toLocalDateTime } from "../../utilities/ConvertDateFormat";
import { saveVendorStock } from "../../services/vendor.service";
import moment from 'moment';
import { Actions } from "../../Actions/Actions";
import { fetchAllNotifications } from "../../seller-apis/apidataField";
import PackageHistoryModal from "./PackageHistoryModal";

var totalMediaCount = 0;
var outerdiv;
var loaderDiv;
let currIndex;
var combKeys = [];
var comburl;
function ProductDetConf(props) {
  let currHistId;
  let alert = useAlert();
  // Category list

  const [categoryName, setcategoryName] = useState();

  const [pDetail, setpDetail] = useState([]);
  const [pPrice, setpPrice] = useState();

  // HSN Modal States
  const [showHSNModal, setShowHSNModal] = useState(false);
  const [pVend, setpVend] = useState([]);
  const [images, setimages] = useState([]);
  const [videos, setvideos] = useState([]);
  const [combinedMedia, setCombinedMedia] = useState([]);
  const [check, setChecked] = useState(true);

  // Function to combine images and videos into a single array
  const createCombinedMedia = () => {
    const media = [];

    // Add images
    images.forEach((image, index) => {
      media.push({
        type: 'image',
        data: image,
        index: index,
        id: `img_${index}`
      });
    });

    // Add videos
    videos.forEach((video, index) => {
      media.push({
        type: 'video',
        data: video,
        index: index,
        id: `vid_${index}`
      });
    });

    setCombinedMedia(media);
  };
  const [inActiveCheck, setinActiveCheck] = useState(false);
  const [proType, setproType] = useState("comb");
  const [paginationIndex, setPaginationIndex] = useState(0);

  // Update combined media when images or videos change
  useEffect(() => {
    createCombinedMedia();
  }, [images, videos]);

  // Confirmation Related States
  const [confirmationShow, setconfirmationShow] = useState(false);
  const [confirmationState, setconfirmationState] = useState(false);
  const [buttonDesign, setButtonDesign] = useState(false);
  const [msgConfirmation, setmsgConfirmation] = useState();
  const [selectedId, setselectedId] = useState();
  const [activDeactiveState, setactivDeactiveState] = useState();
  const [deactiveReason, setdeactiveReason] = useState(false);
  const [ennewloader, setennewloader] = useState("none");

  // Toast

  const [showToast, setshowToast] = useState(false);
  const [ToastMsg, setToastMsg] = useState();

  // Popup related states

  const [updtProVisibility, setupdtProVisibility] = useState(false);

  // Combination related
  const [currcombarr, setcurrcombarr] = useState("");

  //  Offcanvas

  const [offcanshow, setoffcanshow] = useState(false);
  const [offcanstate, setoffcanstate] = useState("askNewPrice");
  const [newPrice, setnewPrice] = useState("-1");
  const [seloption, setseloption] = useState("continueSame");

  // Offcanvas for verify transfer price

  const [offcanshowverify, setoffcanshowverify] = useState(false);
  const [offcanstateverify, setoffcanstateverify] = useState("ask");

  // Offcanvas for showing transfer price history

  const [offcanshowpriceHist, setoffcanshowpriceHist] = useState(false);

  // New Price Offer Popup - SL-978
  const [showNewPriceOfferPopup, setShowNewPriceOfferPopup] = useState(false);
  const [newPriceOfferData, setNewPriceOfferData] = useState(null);

  // New offer price from toolsvilla

  const [vendToolHistArr, setvendToolHistArr] = useState([]);
  const [offerprice, setofferprice] = useState();

  // Image modal

  const [imgmodalShow, setimgmodalShow] = useState(false);

  // Other seller price

  const [lowestPrice, setlowestPrice] = useState(undefined);

  const [gstOptions, setGstOptions] = useState(variables?.gstValues);
  const [gstPercent, setGstPercent] = useState("");
  const [currGst, setCurrGst] = useState("");
  const [showGstbox, setShowGstbox] = useState(false);

  const [attrbs, setattrbs] = useState([]);
  const [currComAttrbs, setcurrComAttrbs] = useState([]);
  const [priceHistoryloaded, setpriceHistoryloaded] = useState(true);
  const [PriceReqType, setPriceReqType] = useState("changeReq");
  const search = useLocation().search;


  const history = useHistory();


  const [mainImg, setMainImg] = useState("");
  const [mainVideo, setMainVideo] = useState("");
  const [videosrc, setVideoSrc] = useState(null);

  const [showMoreDetails, setshowMoreDetails] = useState(false);
  const [currPkgs, setCurrPkgs] = useState([]);
  const monthAbbreviations = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const [isDetailPopupVis, setisDetailPopupVis] = useState("none");
  const [pkgValidation, setPkgValidation] = useState(false);
  const [dimensionValidation, setDimensionValidation] = useState(false);
  const [pkgChanged, setPkgChanged] = useState(false);
  const [showWeightSubmitBtn, setShowWeightSubmitBtn] = useState(false);
  const [weightLocked, setWeightLocked] = useState(false);


  // sl - 712
  const { packages, intitialPackages, dimensionUnit } = useSelector((state) => state.packageReducer);
  const dispatch = useDispatch();
  const [isPackageUpdated, setIsPackageUpdated] = useState(false);
  const [packageViewOnly, setPackageViewOnly] = useState(false)
  const [isWeightRequest, setIsWeightRequest] = useState(false)

  // Weight popup modal states
  const [showWeightModal, setShowWeightModal] = useState(false);
  const [selectedCombinationForWeight, setSelectedCombinationForWeight] = useState(null);

  // Collapsible sections states
  const [isConfigurationsCollapsed, setIsConfigurationsCollapsed] = useState(false);
  const [isDescriptionCollapsed, setIsDescriptionCollapsed] = useState(false);
  const [isShortDescriptionCollapsed, setIsShortDescriptionCollapsed] = useState(false);
  const [isSpecificationCollapsed, setIsSpecificationCollapsed] = useState(false);
  const [isReviewsCollapsed, setIsReviewsCollapsed] = useState(false);

  // Per-cell stock editing states
  const [editingStockCell, setEditingStockCell] = useState(null);
  const [cellStockValue, setCellStockValue] = useState('');
  const [isUpdatingCellStock, setIsUpdatingCellStock] = useState(false);
  const [currTableRowClicked, setCurrTableRowClicked] = useState(null);

  const [acceptDisable, setAcceptDisable] = useState(false)

  // l1-2553
  const [pkgHistoryModalShow, setPkgHistoryModalShow] = useState(false);



  // Weight popup handlers
  const handleWeightModalOpen = (combination) => {
    comburl = combination?.url
    dispatch(resetPackages())
    setSelectedCombinationForWeight([]);
    setPackageViewOnly(false)
    // Find the package data for this combination to get lockStatus and other properties
    const packageData = pDetail.pkgs?.find(pkg => pkg.url === combination.url);
    const lowestPkgs = pDetail?.combination && pDetail?.combination?.length > 0 && pDetail?.combination?.find(comb => comb.url === combination.url);
    dispatch(setReferencePackage(packagesCmtoFt(lowestPkgs?.lowestPkgs || [])))
    const enhancedCombination = {
      ...combination,
      lockStatus: packageData?.lockStatus || false,
      sellerWeightChangeDate: packageData?.sellerWeightChangeDate || combination?.sellerWeightChangeDate,
      sellerWeightChangeSts: combination?.sellerWeightChangeSts || packageData?.sellerWeightChangeSts || null
    };

    if (combination?.sellerWeightChangeSts === "T_PENDING") {
      api.product.getSellerWeightChangePendingReq({ "product": props.match.params.pId, "pkg.url": combination?.url }).then((res) => {
        dispatch(setInitialPackages(packagesCmtoFt(res?.data?.pkgs)))
        if (res?.data?.pkgs?.length > 0) {
          setPackageViewOnly(true)
        }
      }).catch(err => {
        console.log(err)
      })
    }
    else {

      if (combination?.url && packageData) {
        dispatch(setInitialPackages(packagesCmtoFt(packageData.pkgs)));
        dispatch(setEditBtn(checkIsPkgMediaNotPresent(packageData.pkgs)))
        if (enhancedCombination?.sellerWeightChangeSts === "T_ACTIVE" ||
          enhancedCombination?.sellerWeightChangeSts === "T_PENDING" ||
          enhancedCombination?.sellerWeightChangeSts === "V_ACTIVE") {
          setPackageViewOnly(true);
        } else {
          setPackageViewOnly(false);
        }
      }
    }
    setSelectedCombinationForWeight(enhancedCombination);

    setShowWeightModal(true);

  };


  const handleWeightModalClose = () => {
    setShowWeightModal(false);
    setSelectedCombinationForWeight(null);
  };

  // Handle weight request state when modal opens
  useEffect(() => {
    if (selectedCombinationForWeight && showWeightModal) {
      if (selectedCombinationForWeight?.sellerWeightChangeSts === "V_PENDING") {
        setIsWeightRequest(true);
      } else {
        setIsWeightRequest(false);
      }
    }
  }, [selectedCombinationForWeight, showWeightModal]);

  // Per-cell stock editing functions
  const handleCellStockEdit = (combination, currentStock) => {
    setEditingStockCell(combination.url);
    setCellStockValue(currentStock.toString());
  };

  const handleCellStockSave = async (combination) => {
    if (isUpdatingCellStock) return;

    setIsUpdatingCellStock(true);
    try {
      const newStockValue = parseInt(cellStockValue);
      if (isNaN(newStockValue) || newStockValue < 0) {
        alert.error("Please enter a valid stock value");
        return;
      }

      // Use existing stock update logic
      await updateSellerStock(selectedId, newStockValue);

      setEditingStockCell(null);
      setCellStockValue('');
    } catch (error) {
      console.error("Error updating stock:", error);
      alert.error("Failed to update stock");
    } finally {
      setIsUpdatingCellStock(false);
    }
  };

  const handleCellStockCancel = () => {
    setEditingStockCell(null);
    setCellStockValue('');
  };

  //<Start-Here> Ticket: SL-842 Seller Stock
  const [stockEdit, setStockEdit] = useState(false);
  const [inputStockValue, setInputStockValue] = useState(0);

  const [notificationData, setNotificationData] = useState({
    vpriceReqId: null,
    vendorId: null,
    combinationUrl: null,
    source: null
  });

  const styles = {
    container: {
      stock: {
        marginTop: "10px"
      }
    },
    text: {
      currentStock: {
        position: "absolute",
        top: "-7px",
        left: "18px",
        background: "white",
        padding: "0px 5px",
        fontSize: "11px"
      }
    },
    icon: {
      wrapper: {
        position: "relative",
        display: "inline-block",
        width: "20px", // Ensures consistent space for the icon
        height: "20px", // Ensures consistent space for the icon
        paddingRight: "5px"
      },
      editStock: {
        position: "relative",
        top: "-4px",
        left: "-19px",
        fontSize: "15px",
      },
      saveImg: {
        position: "relative",
        top: "-4px",
        left: "-22px"
      }
    },
    input: {
      stock: {
        padding: "9px 22px 2px 11px",
        width: "150px"
      }
    }
  }
  //</End-Here> Ticket: SL-842 Seller Stock

  // l1-2319 (2-9-25)
  // HSN Modal Handlers
  const handleHSNEdit = () => {
    setShowHSNModal(true);
  };

  const handleHSNModalClose = () => {
    setShowHSNModal(false);
  };

  const handleHSNSave = async ({ productId, hsnCode, gstRate }) => {
    let data = {
      _id: productId,
      HSN: hsnCode,
      taxClass: gstRate
    }
    try {
      let res = await api.product.addToExProduct(data)
      if (res.message === "product updated" || res.message === "product added") {
        alert.success("Product updated Successfully!");
        fetchDetails()
        // ✅ Close notification
        await closeNotificationAndRefresh('price');
      }
      else {
        alert.info(res.message);
      }
    }
    catch (err) {
      alert.info("Failed to update HSN");
      console.log(err);
    }
    finally {
      handleHSNModalClose();
    }
  }

  const openReportPopup = () => {
    setisDetailPopupVis("block");
  }
  function setpopupVisibilityDetail() {
    setisDetailPopupVis("none");
  }
  useEffect(() => {
    comburl = decodeURIComponent(new URLSearchParams(search).get("url"));//SL-841
    fetchDetails()
  }, []);

  const fetchDetails = () => {
    setCurrTableRowClicked(null)
    let catList = [];
    combKeys = [];
    let catname;
    currIndex = undefined;
    // Fetch product detail
    let data = {
      pId: props.match.params.pId,
    };
    setselectedId(props.match.params.pId);
    api.product
      .productsRetrieveall(pdetailData(data))
      .then((res) => {
        if (res.products[0].vendors[0].combination.length > 0) {
          res.products[0].vendors[0].combination &&
            res.products[0].vendors[0].combination.map((item, index) => {
              if (item.url === comburl) {
                if (item?.sellerWeightChangeSts === "V_PENDING") {
                  setIsWeightRequest(true)
                }
                if (currIndex === undefined) {
                  currIndex = index;
                }
                //set packages
                let propPkgs = [];
                if (item?.sellerWeightChangeSts === "T_PENDING") {
                  api.product.getSellerWeightChangePendingReq({ "product": props.match.params.pId, "pkg.url": item.url }).then((res) => {
                    dispatch(setInitialPackages(packagesCmtoFt(res?.data?.pkgs)))
                    if (res?.data?.pkgs?.length > 0) {
                      setPackageViewOnly(true)
                    }
                  }).catch(err => {
                    console.log(err)
                  })
                } else {
                  res.products[0].pkgs &&
                    res.products[0].pkgs.map((item1, index) => {
                      if (item1?.url === comburl) {
                        if (item1.lockStatus) {
                          setWeightLocked(true);
                        }
                        if (res.products?.[0]?.isDefaultPkg) {
                          dispatch(resetPackages())
                          setPackageViewOnly(false)
                        }
                        else {
                          dispatch(setInitialPackages(packagesCmtoFt(item1.pkgs)))
                          if (item?.sellerWeightChangeSts === "T_ACTIVE" || item?.sellerWeightChangeSts === "T_PENDING" || item?.sellerWeightChangeSts === "V_ACTIVE") {
                            setPackageViewOnly(true)
                          }
                          else {
                            setPackageViewOnly(false)
                          }
                        }

                        for (const pkg1 of item1.pkgs) {
                          if (pkg1.status === "APPROVED") {
                            pkg1["packageWidthFront"] = (pkg1.packageWidth / 30.48).toFixed(2);
                            pkg1["packageHeightFront"] = (pkg1.packageHeight / 30.48).toFixed(2);
                            pkg1["packageLengthFront"] = (pkg1.packageLength / 30.48).toFixed(2);
                            propPkgs.push(pkg1);
                          }
                        }
                      }
                    });
                  setCurrPkgs(propPkgs);
                }
                //SL-842
                setInputStockValue(item?.stock || 0)
              }
            });
        }
        setimages(res.products[0].images);

        if (res.products[0].images && res.products[0].images.length > 0) {
          let image = res.products[0].images[0].image;
          let baseImg;
          if (image.startsWith("products")) {
            baseImg = image;
          } else if (image.startsWith("mob")) {
            baseImg = image;
          } else {
            let img = image.substr("41");
            baseImg = img;
          }
          setMainImg(baseImg);
        }
        if (res.products[0].videos && res.products[0].videos.length > 0) {
          let video = res.products[0].videos[0];
          if (video.includes("products")) {
            video = "https://media.toolsvilla.com/" + video;
          } else {
            video = "https://www.youtube.com/embed/" + video;
          }
          setMainVideo(video);
        }
        totalMediaCount = totalMediaCount + res.products[0].images.length;
        servicesApi.categories
          .categoryTree({})
          .then((res) => {
            catList = res.data.subCategories;
          })
          .then(() => {
            res.products[0].categories.map((item, index) => {
              catList.map((pitem, pindex) => {
                if (item === pitem._id) {
                  catname = pitem.categoryName;
                }
              });
            });
            setcategoryName(catname);
          })
          .catch((err) => console.log(err));
        setpDetail(res.products[0]);

        // Setting gst class
        if (
          res.products[0].vendors[0].taxClass &&
          res.products[0].vendors[0].taxClass !== "" &&
          res.products[0].vendors[0].taxClass !== undefined
        ) {
          setGstPercent(res.products[0].vendors[0].taxClass);
          setCurrGst(res.products[0].vendors[0].taxClass);
        } else {
          setGstPercent(res.products[0].taxClass);
          setCurrGst(res.products[0].taxClass);
        }

        setvideos(res.products[0].videos);
        totalMediaCount = totalMediaCount + res.products[0].videos.length;

        // For price history
        if (res.products[0].vendors[0].prSts) {
          setpriceHistoryloaded(false);
          let vdata;
          if (
            res.products[0].vendors[0].combination &&
            res.products[0].vendors[0].combination.length > 0
          ) {
            vdata = {
              pageNo: 1,
              selectedId: props.match.params.pId,
              url: comburl,
            };
          }
          api.product
            .vPriceReqRetrieveAll(transferPriceHistory(vdata))
            .then((res) => {
              setpriceHistoryloaded(true);

              if (res.data.length > 0) {
                currHistId = res.data[0]._id;
                setofferprice(res.data[0].price);
              }
              setvendToolHistArr(res.data);
            })
            .catch((err) => console.log(err));
        }
        return res;
      })
      .then((ress) => {
        if (
          ress.products[0].vendors[0].combination &&
          ress.products[0].vendors[0].combination.length > 0
        ) {
          ress.products[0].combination.map((item, index) => {
            if (item.url === comburl) {

              // sl - 712
              dispatch(setReferencePackage(packagesCmtoFt(item?.lowestPkgs)))
              setattrbs(item.value);
              ress.products[0].attributeList.map((citem, cindex) => {
                combKeys.push(citem.attribute.name);
                item.value.map((aitem, aindex) => {
                  if (citem.values.includes(aitem)) {
                    citem.selectedValue = aitem;
                  }
                });
              });
            }
          });
          setproType("comb");
          let cmbString = [];
          let product = ress.products[0];
          let arr = [];
          for (const attr of product.attributeList) {
            if (!attr.selectedValue) {
              return;
            }
            cmbString[
              product.combination[0].value.indexOf(attr.attribute.name)
            ] = attr.selectedValue;
            arr.push(
              cmbString[
              product.combination[0].value.indexOf(attr.attribute.name)
              ]
            );
          }
          setcurrComAttrbs(arr);
          cmbString = cmbString.join("-");
          let foundCmb = false;
          for (const comb of product.combination) {
            if (comb.url && comb.active) {
              if (comb.url === comburl) {
                foundCmb = true;
                product.inActiveVarient = false;
                let isPres = false;
                for (let vurl of product.vendors[0].combination) {
                  if (comburl === vurl.url) {
                    if (
                      vurl.purchase_price !== undefined &&
                      vurl.purchase_price !== ""
                    ) {
                      if (vurl.purchase_price > comb.lowestPrice) {
                        setlowestPrice(comb.lowestPrice);
                      } else {
                        setlowestPrice(undefined);
                      }
                      isPres = true;
                      vurl.actualPrice = comb?.specialPrice ? comb?.specialPrice : comb?.price;
                      setcurrcombarr(vurl);
                      return;
                    } else {
                    }
                    break;
                  } else {
                  }
                }
                if (!isPres) {
                  setPriceReqType("newCombReq");
                }
              }
            }
          }
        }
      })
      .catch((err) => console.log(err));
  }

  useEffect(() => {
    // make notification opened true
    const vndActData = {
      "filter": {
        "product-objectId": props.match.params.pId
      }
    }
    api.notify
      .updateVendorActLogs(vndActData)
      .then((res) => {
        // alert.success("Product updated successfully");
      })
      .catch((err) => {
        console.log(err);
        // alert.error("Failed to update");
      });
  }, [props.match.params.pId]);

  // update seller weight change sts
  const updateSellerWeightChangeSts = async (status) => {
    let data = {
      product: selectedId,
      sellerWeightChangeSts: status,
      url: comburl,
    };
    try {
      const res = await api.product.sellerWeightChangeStsUpdate(data)
        setcurrcombarr({
          ...currcombarr,
          sellerWeightChangeSts: status,
        });
        fetchDetails()
        setShowWeightSubmitBtn(false);
        showPkgEdit();
        alert.success("Details updated");
        setIsPackageUpdated(true);

        // ✅ ADD THIS: Close the notification and update count
        await closeNotificationAndRefresh('weight');
      }
    catch (err) {
      alert.error("Failed to update");
    }
  }

  function checkMinusInput(e) {
    if (e.code === "Minus") {
      e.preventDefault();
    }
  }

  // new weight logic
  function checkMinusInput(e) {
    if (e.code === "Minus") {
      e.preventDefault();
    }
  }

  function showPkgEdit() {
    const nextPkgs = [...currPkgs];
    nextPkgs.map((pkg, index) => {
      pkg.pkgEdit = !pkg.pkgEdit;
    });
    setCurrPkgs(nextPkgs);
  }
  function handlePkgChange(pkgId, key, value) {
    // console.log(pkgId, key, value);
    const nextPkgs = [...currPkgs];
    const pkg = nextPkgs.find((a) => a._id === pkgId);
    if (
      key == "packageWidth" ||
      key == "packageHeight" ||
      key == "packageLength"
    ) {
      pkg[key] = (value * 30.48).toFixed(2);
      if (key == "packageWidth") {
        pkg["packageWidthFront"] = value;
      } else if (key == "packageHeight") {
        pkg["packageHeightFront"] = value;
      } else {
        pkg["packageLengthFront"] = value;
      }

      pkg.vWeight =
        (pkg.packageWidth * pkg.packageLength * pkg.packageHeight) / 5000;
      pkg.vWeight = pkg.vWeight.toFixed(2);
    } else {
      pkg[key] = value;
    }
    //validation
    if (
      !pkg.weight ||
      pkg.weight <= 0 ||
      !pkg.actualWeight ||
      pkg.actualWeight <= 0
    ) {
      setPkgValidation(true);
      // setweightToastMsg("please enter a valid weight");
      // settoastweight("block");
    } else if (
      pkg.packageHeight <= 0 ||
      pkg.packageLength <= 0 ||
      pkg.packageWidth <= 0
    ) {
      setDimensionValidation(true);
      // setweightToastMsg(
      //   "please enter a valid dimension (height, width, length)"
      // );
      // settoastweight("block");
    } else {
      setDimensionValidation(false);
      setPkgValidation(false);
      // setweightToastMsg("");
      // settoastweight("none");
    }
    setCurrPkgs(nextPkgs);
    setPkgChanged(true);
  }

  // Deactivate product
  function changeToggle() {
    setdeactiveReason(true);
    setactivDeactiveState("deactivate");
    // setselectedId(id)
    setmsgConfirmation(
      `Are you sure you want to make this product "Out of Stock" ?`
    );
    setButtonDesign(true);
    setconfirmationState(true);
  }

  // Activate product
  function changeinActivetoggle() {
    setdeactiveReason(false);

    setactivDeactiveState("activate");
    // setselectedId(id)
    setmsgConfirmation(
      `Are you sure you want to make this product "In Stock" ?`
    );
    setButtonDesign(false);
    setconfirmationState(true);
  }

  // Confirmation Modal
  function confirmationBoxHiding(state) {
    if (state === false) {
      setconfirmationState(false);
      setButtonDesign(true);
    }
  }

  function reloadData() {
    setPriceReqType("changeReq");
    handleCloseoffcan();
    handleCloseoffcanpriceHist();
    handleCloseoffcanverify();
    let vdata;
    // For price history
    vdata = {
      pageNo: 1,
      selectedId: props.match.params.pId,
      url: comburl,
    };
    api.product
      .vPriceReqRetrieveAll(transferPriceHistory(vdata))
      .then((res) => {
        if (res.data.length > 0) {
          currHistId = res.data[0]._id;
          setofferprice(res.data[0].price);
        }
        setvendToolHistArr(res.data);
      })
      .catch((err) => console.log(err));
  }

  // Response Confirmation
  async function responseconfirmation(ans, productId, stock, reason) {
    setconfirmationState(false);
    if (ans === "yes") {
      // apprscrollLen = 1;
      if (activDeactiveState === "activate") {
        try {
          let data;
          if (proType === "comb") {
            data = {
              "_id": productId,
              "vActive": "ACTIVE",
              "url": currcombarr.url,
              "stock": stock
            }
          }
          // l1-2341 (9-9-25)
          await handleSaveVendorStock("In Stock", stock);
          api.product
            .addToExProduct(data)
            .then((res) => {
              pDetail.vendors[0].combination[currIndex].vActive = "ACTIVE";
              setpDetail(pDetail);
              setcurrcombarr({
                ...currcombarr,
                vActive: "ACTIVE",
              });
              alert.success("Stock updated successfully.")
              fetchDetails();
            })
            .catch((err) => {
              console.log(err);
            });
        } catch (err) {
          console.log("Stock update aborted due to vendor stock error:", err);
        }
      } else if (activDeactiveState === "deactivate") {
        try {
          let data;
          if (proType === "comb") {
            data = {
              "_id": productId,
              "vActive": "INACTIVE",
              "reason": reason,
              "url": currcombarr.url
            }
          }
          // l1-2341 (9-9-25)
          await handleSaveVendorStock("Out Of Stock", 0);
          api.product
            .addToExProduct(data)
            .then((res) => {
              // alert.success("Inactive request sent");
              pDetail.vendors[0].combination[currIndex].vActive = "INACTIVE";
              setpDetail(pDetail);
              setcurrcombarr({
                ...currcombarr,
                vActive: "INACTIVE",
              });
              alert.success("Stock updated successfully.")
              fetchDetails();
            })
            .catch((err) => {
              console.log(err);
            });
        } catch (err) {
          console.log("Stock update aborted due to vendor stock error:", err);
        }
      }
    }
  }

  // l1-2341 (9-9-25)
  const handleSaveVendorStock = async (stockStatus, stockVal) => {

    try {
      console.log(pDetail, currcombarr)
      let data = {
        "product": pDetail?._id,
        "vendor": pDetail?.vendors?.[0]?.vendor_id,
        "taxClass": pDetail?.vendors?.[0]?.taxClass,
        "purchase_price": currcombarr?.purchase_price,
        "stock": stockVal,
        "status": "AUTOAPPROVED",
        "stockStatus": stockStatus,
        "site_price": currcombarr?.actualPrice,
        "categories": pDetail?.categories,
        "combination.url": currcombarr?.url,
        "receivedFrom": "seller"
      }
      console.log(currcombarr)
      const res = await saveVendorStock(data)
    } catch (err) {
      console.log(err)
      alert.error(err.message || "Failed to update stock status");
      // Re-throw the error so the calling function knows it failed
      throw err;
    }
  }

  // Inactive request click
  const handleToast = () => {
    setToastMsg("Inactive request already sent to Toolsvilla");
    setshowToast(true);
  };

  // Offcanvas show/hide
  const handleCloseoffcan = () => {
    setnewPrice();
    setoffcanshow(false);
    setoffcanstate("askNewPrice");
    setseloption("");
  };

  const handleCloseoffcanverify = () => {
    setnewPrice();
    setoffcanshowverify(false);
    setoffcanstateverify("ask");
  };
  const handleopenoffcan = () => setoffcanshow(true);
  const handleopenoffcanverify = () => setoffcanshowverify(true);
  const handleopenoffcanpriceHist = () => setoffcanshowpriceHist(true);
  const handleCloseoffcanpriceHist = () => setoffcanshowpriceHist(false);

  // Check price
  function checkenterprice(e) {
    setnewPrice(e);
  }

  function applyLoader() {
    outerdiv = document.getElementById("orDeskContain");
    loaderDiv = document.getElementById("enNewLoader");
    loaderDiv.classList.add("loader-bt");
    setennewloader("flex");
    outerdiv.classList.add("div-bk");
  }

  function removeLoader() {
    setennewloader("none");
    loaderDiv.classList.remove("loader-bt");
    outerdiv.classList.remove("div-bk");
  }

  // New price request fun offcanvas 2 state
  const newPriceReq = () => {
    if (
      newPrice === undefined ||
      newPrice === "" ||
      newPrice < 1 ||
      newPrice.includes(".")
    ) {
      alert.info("Please enter a valid new price.");
    } else {
      document.getElementById("sub_newreq").disabled = true;
      if (proType === "comb") {
        applyLoader();
        setupdtProVisibility(false);
        if (PriceReqType === "newCombReq") {
          //SL-841
          const currentSelectedCombURL =
            currcombarr != undefined && currcombarr.url != undefined ? currcombarr.url
              : comburl != undefined ? comburl : undefined;
          let chCom = {
            "url": currentSelectedCombURL,//currcombarr.url,//SL-841
            "purchase_price": newPrice
          }
          let data = {
            _id: selectedId,
            combination: chCom,
            addCombinationFlag: true,
          };
          // SL-1035
          data["receivedFrom"] = "product_detail"
          handleCloseoffcan()
          api.product
            .addToExProduct(data)
            .then(async (res) => {
              if (
                res.message === "product updated" ||
                res.message === "product added"
              ) {
                alert.success("Combination added");
                removeLoader();
                fetchDetails();
              }
            })
            .catch((err) => console.log(err));
        } else {
          let data = {
            product: selectedId,
            price: newPrice,
            url: comburl,
          };
          // SL-1035
          data["receivedFrom"] = "Product Detail Page"
          api.transferprice
            .priceChangeRquest(data)
            .then(async (res) => {
              if (res.message === "price change request submitted") {
                if (currcombarr.vActive === "INACTIVE") {
                  changeinActivetoggle();
                }
                if (currcombarr.purchase_price < newPrice) {
                  alert.success(
                    "New price request successfully sent to Toolsvilla"
                  );
                }
                fetchDetails();
                removeLoader();
                await closeNotificationAndRefresh('price');
              } else {
                alert.info(res.message);
                removeLoader();
              }
              handleCloseoffcan();

            })
            .catch((err) => {
              console.log(err);
              removeLoader();
            });
        }
      }
      handleCloseoffcanverify();
      document.getElementById("sub_newreq").disabled = false;
    }
  };

  // Image modal

  const imgmodalhandleClose = () => setimgmodalShow(false);
  const imgmodalhandleShow = () => setimgmodalShow(true);

  // Accept or reject transfer price

  function priceReqfromTool(spcl) {
    if (spcl === "reject") {
      handleopenoffcan();
    } else {
      let data;
      data = {
        "product": selectedId,
        "_id": vendToolHistArr[0]._id,
        "status": "V_ACTIVE",
        "price": offerprice,
        "url": currcombarr.url
      }
      api.transferprice.updatePriceRequest(data).then((res) => {
        if (res.message === "price request updated") {
          setcurrcombarr({
            ...currcombarr, prSts: "V_ACTIVE", purchase_price: offerprice
          })
          if (currcombarr.vActive === "INACTIVE") {
            changeinActivetoggle()
          }
          pDetail.vendors[0].combination[currIndex].purchase_price = offerprice;
          pDetail.vendors[0].combination[currIndex].prSts = "V_ACTIVE";
          setpDetail(pDetail);
          alert.success("Price request updated");
          if (lowestPrice > offerprice) {
            setlowestPrice(undefined)
          }

          reloadData();
        }
      })
        .catch((err) => console.log(err));
    }
  }

  // SL-978: Handler functions for NewPriceOfferPopup
  const handleNewPriceOfferAccept = async (selectedCombination) => {
    setAcceptDisable(true)
    const targetUrl = selectedCombination?.url || currcombarr?.url;
    const newOfferPrice = selectedCombination?.n_purchase_price || offerprice;
    try {
      let priceHistRes = await handlePriceHistory(targetUrl);
      if (priceHistRes?.data?.length > 0) {
        currHistId = priceHistRes?.data?.[0]._id;
      }
      else {
        alert.error("There is some issue, please contact support.")
        return;
      }
      let data = {
        "product": selectedId,
        "_id": currHistId,
        "status": "V_ACTIVE",
        "price": newOfferPrice,
        "url": targetUrl
      };

      let res = await api.transferprice.updatePriceRequest(data);
      if (res.message === "price request updated" || res.message === "price change request submitted") {
        // Update the combination in state
        const combIndex = pDetail.vendors[0].combination.findIndex(c => c.url === targetUrl);
        if (combIndex !== -1) {
          pDetail.vendors[0].combination[combIndex].purchase_price = newOfferPrice;
          pDetail.vendors[0].combination[combIndex].prSts = "V_ACTIVE";
        }
        if (currcombarr.url === targetUrl) {
          setcurrcombarr({
            ...currcombarr,
            prSts: "V_ACTIVE",
            purchase_price: newOfferPrice
          });
        }
        setpDetail(pDetail);
        alert.success("Price offer accepted successfully");
        setShowNewPriceOfferPopup(false);
        // ✅ ADD THIS: Close the price notification
        await closeNotificationAndRefresh('price');
        reloadData();
      }
    } catch (err) {
      console.log(err)
    }
    finally {
      setAcceptDisable(false)
    }
  };

  const handleNewPriceOfferReject = () => {
    // Close the popup, no action needed for rejection
    setShowNewPriceOfferPopup(false);
  };

  const handleNewPriceOfferSubmit = (newPrice) => {
    if (!newPrice || newPrice <= 0) {
      alert.error("Please enter a valid price");
      return;
    }

    let data = {
      "product": selectedId,
      "price": newPrice,
      "url": currcombarr.url,
    };

    api.transferprice.priceChangeRquest(data).then((res) => {
      if (res.message === "price change request submitted" || res.message === "price request updated") {
        const combIndex = pDetail.vendors[0].combination.findIndex(c => c.url === currcombarr.url);
        if (combIndex !== -1) {
          pDetail.vendors[0].combination[combIndex].purchase_price = newPrice;
          pDetail.vendors[0].combination[combIndex].prSts = "T_PENDING";
        }

        setcurrcombarr({
          ...currcombarr,
          prSts: "T_PENDING",
          purchase_price: newPrice
        });

        setpDetail(pDetail);
        alert.success("New price request submitted to Toolsvilla");
        setShowNewPriceOfferPopup(false);
        reloadData();
      }
    }).catch((err) => {
      console.log(err);
      alert.error("Failed to submit price request");
    });
  };

  // Verify transfer price after 1 popup

  async function noVerifyPrice() {
    setoffcanstateverify("askNewPrice");

    // ✅ ADD THIS: Close the notification when user says NO
    await closeNotificationAndRefresh('price');
  }


  async function yesVerifyPrice() {
    try {
      if (proType === "comb") {
        if (!currcombarr.prSts) {
          let data = {
            _id: selectedId,
            purchase_price: pPrice,
            prSts: "V_ACTIVE",
            url: currcombarr.url
          };

          await api.product.addToExProduct(data);

          alert.success("Transfer price verified");

          if (currcombarr.vActive === "INACTIVE") {
            changeinActivetoggle();
          }

          fetchDetails();
        } else {
          let data = {
            _id: currHistId,
            product: selectedId,
            purchase_price: pPrice,
            prSts: "V_ACTIVE",
            url: comburl,
          };

          await api.transferprice.updatePriceRequest(data);

          reloadData();

          if (currcombarr.vActive === "INACTIVE") {
            changeinActivetoggle();
          }
        }
      }

      handleCloseoffcanverify();
      handleCloseoffcan();

      // ✅ Close the notification and refresh count after verifying price
      await closeNotificationAndRefresh('price');

    } catch (error) {
      console.error('Error verifying price:', error);
      alert.error("Failed to verify price");
    }
  }


  // Function to close all popups opened
  document.onkeydown = function (evt) {
    evt = evt || window.event;
    if (evt.key === "Esc" || evt.key === "Escape") {
      setupdtProVisibility(false);
      handleCloseoffcan();
      handleCloseoffcanpriceHist();
      handleCloseoffcanverify();
    }
  };

  // Confirmation
  function responseconfirmationonly(ans) {
    if (ans) {
      changeGST();
    }
  }

  // Change GST %
  async function changeGSTFun() {
    if (gstPercent == currGst) {
      alert.info("Default Gst");
    } else {
      setmsgConfirmation(
        "Are you sure you want to change GST % to " + gstPercent + "% ?"
      );
      setconfirmationShow(true);
    }
  }

  function changeGST() {
    let data = {
      _id: selectedId,
      taxClass: gstPercent,
    };
    api.product
      .addToExProduct(data)
      .then((res) => {
        alert.success("Updated successfully");
        setconfirmationShow(false);
        setCurrGst(gstPercent);
        setGstPercent(gstPercent);
      })
      .catch((err) => console.log(err));
  }

  // Set different pics acc to attributes

  function setCombPic(comb) {
    let img;
    for (img in comb.images) {
      // console.log(img);
      if (comb.images[img].baseImage) {
        setMainImg(comb.images[img].image);
      }
    }
  }

  function scroll(spcl) {
    var doc = document.getElementById("pd_img_list_box_cntn_id");
    if (spcl === "l") {
      doc.scrollLeft -= 200;
    } else {
      doc.scrollLeft += 200;
    }
  }

  // sl-712
  const handlePackageSubmission = async () => {
    try {
      if (arePackagesEqual(packages, intitialPackages)) {
        await updateSellerWeightChangeSts("V_ACTIVE");
        return;
      }
      if (isPackageLocked(currcombarr?.sellerWeightChangeSts) && checkIsPkgMediaNotPresent(packages)) {
              alert.error("Please upload images for package(s) before submitting.");
              return;
      }
      let pkgData;
      pkgData = {
        product: selectedId,
        status: "T_PENDING",
        pkg: { url: comburl, pkgs: dimensionUnit === "cm" ? packages : packagesFttoCm(packages) },
        categories: pDetail?.categories,
        requestType: "EXISTING_PRODUCT"
      };
      const sanitizedPkgData = sanitizePkgImages(pkgData);
      await api.product.saveSellerWeightChangeReq(sanitizedPkgData)
      fetchDetails()
      setShowWeightSubmitBtn(false);
      showPkgEdit();
      alert.success("Details updated");
      setIsPackageUpdated(true);
      // ✅ ADD THIS: Close notification after submitting weight changes
      await closeNotificationAndRefresh('weight');
      handleWeightModalClose()
    } catch (err) {
      handleWeightModalClose()
      alert.error("error")
    }
  }

  //<Start-Here> Ticket: SL-699 Seller Stock
  /**
   * SL - 699
   * Handle Stock Change
   * @param {*} id 
   * @param {*} value 
   */
  const handleStockChange = (stockValue) => {
    //Only allow numeric values
    if (/^\d*$/.test(stockValue))
      setInputStockValue(stockValue);
  };
  /**
   * Handle Edit Click
   * @param {*} id 
   */
  const handleStockEditClick = (value) => {
    setStockEdit(value); // Set the editable row
    //setInputStockValue(stockValue); // Reset to the original value when editing starts
  };
  /**
   * Handle Save Click
   */
  const handleStockSaveClick = () => {

    // Validation: Ensure the input is a positive number or zero
    if (isNaN(inputStockValue)) {
      alert.error("Please enter a valid number.");
      return;
    }
    const numericValue = Number(inputStockValue);
    if (numericValue < 0) {
      alert.error("Please enter a valid positive number.");
      return;
    }
    updateSellerStock(selectedId, numericValue)// Save changes and make the input box non-editable
  };

  //Sl-699 : Seller Stock Update
  async function updateSellerStock(id, stock) {
    console.log("Updating stock to:", stock, id)
    let comb = {
      "url": currcombarr.url,
      "stock": stock,
      "vActive": "ACTIVE",
      "reason": ""
    }
    let data = {
      "_id": id,
      "combination": comb
    }
    //if given 0, then out of stock
    if (stock == 0){
        data["vActive"] = "INACTIVE";
        data.combination.vActive = "INACTIVE";
    }

    // l1-2341
    if ((Number(currcombarr?.stock) || 0) < 1 && stock > 0) {
      await handleSaveVendorStock("In Stock", stock)
    }
    else if (Number(stock) === 0) {
      await handleSaveVendorStock("Out Of Stock", stock)
    }

    await api.product.addToExProduct(data)
      .then((res) => {
        alert.success("Stock Updated Successfully!")
        fetchDetails();
      }).catch(err => console.log(err))

  }
  //</End-Here> Ticket: SL-699 Seller Stock

  // Sl-978
  const handleActionRequiredClick = (isVerifyTransferPriceParam, isNewPriceOfferParam, combination) => {
    if (isNewPriceOfferParam) {
      // Prepare data for NewPriceOfferPopup2 with current selected combination only
      // Skip first combination (index 0) as it contains attribute names, not values
      const productComb = pDetail?.combination?.slice(1).find(pc => pc.url === combination?.url);

      // Create configuration name from product combination values (actual values, not attribute names)
      let displayName = '';
      if (productComb && productComb.value && Array.isArray(productComb.value)) {
        displayName = productComb.value.join(' / ');
      } else {
        displayName = combination?.url || 'Combination';
      }

      setNewPriceOfferData({
        productName: pDetail?.productName,
        currentPrice: combination?.purchase_price || offerprice,
        newPrice: combination?.n_purchase_price || offerprice,
        taxClass: currGst || pDetail?.vendors?.[0]?.taxClass,
        currentCombination: {
          url: combination?.url,
          cmb: displayName,
          n_purchase_price: combination?.n_purchase_price || offerprice,
          purchase_price: combination?.purchase_price || 'N/A',
          stock: combination?.stock
        },
        vendor: pDetail?.vendors?.[0]
      });
      setShowNewPriceOfferPopup(true);
    } else if (isVerifyTransferPriceParam) {
      handleopenoffcanverify()
    }
  }

  const setCurrSelectedCombination = (vendorCombination, productCombination, index) => {
    setCurrTableRowClicked(index)
    setcurrcombarr(vendorCombination)
    if(vendorCombination?.purchase_price > productCombination?.lowestPrice){
      setlowestPrice(productCombination?.lowestPrice)
    }
    else{
      setlowestPrice(undefined)
    }
    comburl = vendorCombination?.url
  }

  const handlePriceHistoryClick = async (url) => {
    try {
      let res = await handlePriceHistory(url);
      setpriceHistoryloaded(true);
      if (res?.data?.length > 0) {
        currHistId = res.data[0]._id;
        setofferprice(res.data[0].price);
      }
      setvendToolHistArr(res.data);
      handleopenoffcanpriceHist()
    } catch (err) {
      console.log(err);
    }
  }


  const handlePriceHistory = async (url) => {
    let vdata = {
      pageNo: 1,
      selectedId: props.match.params.pId,
      url: url,
    };
    try {
      let res = await api.product.vPriceReqRetrieveAll(transferPriceHistory(vdata));
      return res;
    }
    catch (err) {
      console.log(err)
    }
  }

  const acceptLowestPrice = async (competitorPrice, vendor) => {
    try {
      applyLoader()
      let data = {
        product: selectedId,
        price: competitorPrice,
        url: vendor?.url
      };
      data["receivedFrom"] = "Product Detail Page"
      const res = await api.transferprice.priceChangeRquest(data);
      if (res.message === "price request updated" || res.message === "price change request submitted") {
        alert.success("Price accepted successfully");
      }else{
        alert.info(res?.message);
      }
      fetchDetails()
    } catch (err) {
      alert.error("Error occured, please try again.")
    }
    finally {
      removeLoader()
    }
  }
  const closeNotificationAndRefresh = async (notificationType) => {
    try {
      const vendorId = localStorage.getItem('vendorId');

      if (notificationType === 'price') {
        // Close price notification
        await api.notify.closeVendorPriceNotification({
          productId: String(selectedId),
          vendorId: String(vendorId),
          combinationUrl: comburl || notificationData.combinationUrl,
          source: notificationData.source || 'notification',
          vpriceReqId: notificationData.vpriceReqId ? String(notificationData.vpriceReqId) : undefined,
        });
      } else if (notificationType === 'weight') {
        // Close weight notification  
        await api.notify.closeVendorWeightNotification(
          String(selectedId),
          String(vendorId)
        );
      }

      // ✅ Update vendor activity log to refresh bell icon count
      await api.notify.updateVendorActLogs({
        filter: {
          "product-objectId": selectedId
        }
      });

      // ✅ Fetch latest notification count and update Redux
      const dateFromWeb = moment().subtract(15, 'days').format('YYYY-MM-DD');
      const dateToWeb = moment().format('YYYY-MM-DD');

      // const countData = {
      //   pageNo: 1,
      //   size: 1,
      //   filters: {
      //     type: { $in: ["PRC_CHANGED"] },
      //     opened: false,
      //     "from-createdAt": dateFromWeb + 'T00:00:00.000Z',
      //     "to-createdAt": dateToWeb + 'T23:59:59.000Z'
      //   },
      // };

      // const res = await api.notify.fetchNotifications(fetchAllNotifications(countData));

      // // ✅ Update Redux with new count (this updates the bell icon)
      // Actions.updateNotificationCount(dispatch, res.totalRecords);

    } catch (error) {
      console.error('Error closing notification:', error);
      // Don't show error to user, fail silently
    }
  };


  return (
    <div className="detail-new mb-4" id="orDeskContain">
      <div className="pd-conf-layout">
        <div className="pd-conf-media-col">
          <div className="container">
            <div className="pd_img_main_box">
              {combinedMedia.length > 0 ? (
                <>
                  {paginationIndex < combinedMedia.length && combinedMedia[paginationIndex].type === 'image' ? (
                    <img
                      src={"https://s3.toolsvilla.com/" + mainImg}
                      className=""
                      alt="img"
                    />
                  ) : paginationIndex < combinedMedia.length && combinedMedia[paginationIndex].type === 'video' ? (
                    <div className="pd_video_main_box">
                      {videosrc?.includes("products") ? (
                        <video
                          controls
                          className=""
                          src={"https://media.toolsvilla.com/" + videosrc}
                          alt="Product Video"
                        />
                      ) : (
                        <iframe
                          allowFullScreen
                          className=""
                          src={"https://www.youtube.com/embed/" + videosrc}
                        ></iframe>
                      )}
                    </div>
                  ) : null}
                  <div className="pagination-dot-container">
                    {combinedMedia.map((media, index) => {
                      return (
                        <div
                          key={media.id}
                          onClick={() => {
                            if (media.type === 'image') {
                              setMainImg(media.data.image);
                              setPaginationIndex(index);
                            } else {
                              setVideoSrc(media.data);
                              setPaginationIndex(index);
                            }
                          }}
                          className={`pagination-dot ${paginationIndex == index ? "active" : ""}`}
                        ></div>
                      );
                    })}
                  </div>
                </>
              ) : (
                <></>
              )}
            </div>
            <div className="image-thumbnail-slider my-4">
              {combinedMedia && combinedMedia.length > 3 ? (
                // <i
                //   className="fa fa-chevron-circle-left"
                //   id="pd_img_chevron_left"
                //   aria-hidden="true"
                //   onClick={() => scroll("l")}
                // ></i>
                <img src="/left-slide-icon.webp" className="slider-icon" alt="icon" onClick={() => scroll("l")} />
              ) : (
                <></>
              )}
              <div
                className="pd_img_list_box_cntn"
                id="pd_img_list_box_cntn_id"
              >
                {combinedMedia.map((media, index) => {
                  return (
                    <div
                      key={media.id}
                      className={`pd_img_list_box ${paginationIndex == index ? "active" : ""}`}
                      role="button"
                      onClick={() => {
                        if (media.type === 'image') {
                          setMainImg(media.data.image);
                          setPaginationIndex(index);
                        } else {
                          setVideoSrc(media.data);
                          setPaginationIndex(index);
                        }
                      }}
                    >
                      {media.type === 'image' ? (
                        <img
                          className=""
                          src={
                            "https://s3.toolsvilla.com/" + media.data.image
                          }
                          alt="Product Img"
                        />
                      ) : (
                        <div className="video-thumbnail-item">
                          <div className="play-icon">
                            <i className="bi bi-play-fill"></i>
                          </div>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
              {combinedMedia && combinedMedia.length > 3 ? (
                // <i
                //   className="fa fa-chevron-circle-right"
                //   id="pd_img_chevron_right"
                //   aria-hidden="true"
                //   onClick={() => scroll("r")}
                // ></i>
                <img src="/right-slide-icon.webp" className="slider-icon" alt="icon" onClick={() => scroll("r")} />
              ) : (
                <></>
              )}
            </div>

          </div>
        </div>
        <div className="pd-conf-content-col">
          <Row className=" ">
            <Row className="mb-2">
              <div className="col-12 pr-0">
                <span className="pd_category_label">Category</span> :{" "}
                <span className="pd_category_name">{categoryName}</span>
                <div className="mt-1">
                  <span className="pd_pName">{pDetail.productName}</span>
                </div>
                <div className="product-information">
                  <div>
                    <div className="sku-data mt-2">
                      <span className="">SKU</span> :{" "}
                      <span className="">{pDetail.SKU}</span>
                      <span className="ms-4">HSN</span> :{" "}
                      <span className="">{pDetail.vendors?.[0]?.HSN || 'Not Available'}</span>
                      <img src="/edit-icon.webp" onClick={handleHSNEdit} className="pd_change_Price_pencil ms-1" />
                      <span className="ms-4">GST : </span>
                      <span>
                        {pDetail?.vendors?.[0]?.taxClass ??
                          pDetail?.taxClass ??
                          "N/A"}%
                      </span>
                    </div>
                  </div>
                </div>
              </div>

            </Row>
            <div>
              <button
                className="productissuebut"
                onClick={() => openReportPopup()}
              >
                <img src={'/report-product.webp'} style={{ width: '12%' }} /> Report wrong listing
              </button>
            </div>
            <div className="text-center "></div>



          </Row>
          <div className="m-2">
        {/* Product Configurations & Weights Table */}
        <div
          className="d-flex align-items-center mb-3"
          style={{ cursor: 'pointer' }}
          onClick={() => setIsConfigurationsCollapsed(!isConfigurationsCollapsed)}
        >
          <i className="bi bi-box me-2" style={{ fontSize: '18px', color: '#339a99' }}></i>
          <h6 className="mb-0" style={{ color: '#333' }}>Product Configurations & Weights</h6>
          <i
            className={`bi ${isConfigurationsCollapsed ? 'bi-chevron-right' : 'bi-chevron-down'} ms-auto`}
            style={{ fontSize: '16px', color: '#666' }}
          ></i>
        </div>

        {!isConfigurationsCollapsed && (
          <div className="table-responsive">
            <table className="table product-Det-Conf-Table" style={{ fontSize: '14px' }}>
              <thead style={{ backgroundColor: '#f8f9fa' }}>
                <tr>
                  <th style={{ fontWeight: '600', padding: '12px' }}>Configuration</th>
                  <th style={{ fontWeight: '600', padding: '12px' }}>Your Price</th>
                  <th style={{ fontWeight: '600', padding: '12px' }}>Lowest Competitor</th>
                  <th style={{ fontWeight: '600', padding: '12px' }}>Stock</th>
                  <th style={{ fontWeight: '600', padding: '12px' }}>Packages</th>
                </tr>
              </thead>
              <tbody>
                {pDetail && pDetail.combination && pDetail.combination.slice(1).map((productCombination, index) => {
                  // Find the corresponding vendor combination for this product combination
                  const vendorCombination = pDetail.vendors && pDetail.vendors[0] && pDetail.vendors[0].combination
                    ? pDetail.vendors[0].combination.find(vendorComb => vendorComb.url === productCombination.url)
                    : null;

                  let pkgCount = 0;

                  // Create configuration name with attribute names
                  const attributeNames = pDetail.combination && pDetail.combination[0] ? pDetail.combination[0].value : [];
                  const configurationName = productCombination.value.map((value, valueIndex) => {
                    return `${value}`;
                  }).join(' / ');

                  // Use vendor data if available, otherwise use defaults
                  const stock = vendorCombination ? vendorCombination.stock : 0;
                  const purchasePrice = vendorCombination ? vendorCombination.purchase_price : 0;
                  const saleDiscount = vendorCombination ? vendorCombination.saleDiscount : 0;
                  if (vendorCombination?.sellerWeightChangeSts !== "T_PENDING") {
                    const pkgs = pDetail?.pkgs ? pDetail?.pkgs.find(pkg => pkg?.url === vendorCombination?.url) : null;
                    pkgCount = pkgs?.pkgs?.length || 0;
                  }
                  else {
                    pkgCount = vendorCombination?.sellerWeightChangeReq
                  }
                  const lowestPrice = productCombination?.lowestPrice;

                  const competitorPrice = lowestPrice;
                  const isHigherThanMarket = competitorPrice && purchasePrice > competitorPrice;

                  // Show weight status
                  const weightStatus = vendorCombination?.sellerWeightChangeSts === "T_PENDING" ? "Your requested weight is pending" : vendorCombination?.sellerWeightChangeSts === "T_REJECT" ? "Weight request rejected" : vendorCombination?.sellerWeightChangeSts === "V_PENDING" ? "New weight request from toolsvilla" : "";

                  // Show price edit 
                  const showPriceEdit = (vendorCombination?.prSts === "V_ACTIVE" ||
                    vendorCombination?.prSts === "V_REJECT" ||
                    vendorCombination?.prSts === "T_ACTIVE" ||
                    vendorCombination?.prSts === "T_REJECT") ? true : false

                  // Check is new price offer
                  const isNewPriceOffer = vendorCombination?.prSts === "V_PENDING";

                  // Is verify transfer price
                  const isVerifyTransferPrice = !vendorCombination?.prSts && vendorCombination?.purchase_price ? true : false;

                  // Show action required
                  const actionRequried = isNewPriceOffer || isVerifyTransferPrice;

                  // Show price verification pending
                  const showPriceVerificationPending = vendorCombination?.prSts === "T_PENDING" ? true : false;

                  // Show agree msg
                  const showAgreeMsg = showPriceVerificationPending && vendorCombination?.vActive !== "INACTIVE" ? true : false;


                  const isInactive = !productCombination.active;

                  // Show add now button
                  const showAddNowButton = (!vendorCombination || vendorCombination?.purchase_price === undefined || vendorCombination?.purchase_price === "") ? true : false;

                  // Price history
                  const showPriceHistory = vendorCombination?.sellerPriceChangeReq && vendorCombination?.sellerPriceChangeReq > 0 ? true : false;


                  return (
                    <tr
                      key={index}
                      onClick={() => isInactive ? null : setCurrSelectedCombination(vendorCombination, productCombination, index)}
                      className={isInactive ? 'disabled-row' : index === currTableRowClicked ? 'pd-selected-row11' : ''}
                      style={{
                        opacity: isInactive ? 0.5 : 1,
                        pointerEvents: isInactive ? 'none' : 'auto',
                        cursor: isInactive ? 'not-allowed' : 'pointer',
                      }}
                    >
                      <td style={{ padding: '3px', fontWeight: '500' }}><span className="bg-gray-100 pd-table-conf text-gray-700 fs-12">{configurationName}</span></td>
                      <td style={{ padding: '12px' }}>
                        {!productCombination.active ? (
                          <span className="text-muted fw-bold fs-15">Not Available</span>
                        ) : vendorCombination && !showAddNowButton ? (
                          <span className="text-gray-900 f-600 fs-15">₹ {purchasePrice || 'N/A'}
                            {showPriceHistory ? <img src="/info-icon.webp" onClick={() => handlePriceHistoryClick(vendorCombination?.url)} className="vendor-his-icon" /> : <></>}
                            {!saleDiscount && showPriceEdit ? <img src="/edit-icon.webp" onClick={() => {
                              setPriceReqType("changeReq")
                              handleopenoffcan()
                            }} className="pd_change_Price_pencil ms-2" /> : <></>}
                          </span>
                        ) : showAddNowButton ? (
                          <button
                            className="add_com_12"
                            onClick={() => {
                              setPriceReqType("newCombReq")
                              handleopenoffcan()
                            }
                            }
                          >
                            Add Now
                          </button>
                        ) : <></>}
                        {
                          showPriceVerificationPending ? <><p className="text-warning fs-10 fw-bold">Price Verification Pending {
                            showAgreeMsg ? <OverlayTrigger
                              key="tds"
                              placement="bottom"
                              overlay={
                                <Tooltip id={`tooltip-tds`} className="fs-16 order_page_tooltip">
                                  <p className='fs-10 f-500 payment_page_tooltip_1'> You agree to keep selling at the present price until the
                                    transfer price is confirmed.
                                  </p>
                                </Tooltip>
                              }
                            >
                              <i className="fa fa-info-circle info-334" style={{ color: "black", fontSize: "13px" }} aria-hidden="true"></i>
                            </OverlayTrigger> : <></>
                          }</p> </> : null
                        }


                        {
                          actionRequried ? (<p className="text-danger fs-10 fw-bold" onClick={() => handleActionRequiredClick(isVerifyTransferPrice, isNewPriceOffer, vendorCombination)}>Action Required <i className="bi bi-exclamation-circle"></i></p>) : null
                        }
                      </td>
                      <td style={{ padding: '12px' }}>
                        {competitorPrice && isHigherThanMarket ? (
                          <div>
                            <span className="text-gray-900 f-500 fs-15">₹ {competitorPrice}</span>
                            <div className="text-danger fs-10 fw-bold">{purchasePrice && <>Higher than market</>}
                              <br />
                              {showPriceEdit && <button className="accept-pd-price-134" onClick={() => acceptLowestPrice(competitorPrice, vendorCombination)}>Accept</button>}
                            </div>
                          </div>
                        ) : (
                          <span className="text-muted">No data</span>
                        )}
                      </td>
                      <td style={{ padding: '12px', textAlign: 'center' }}>
                        {editingStockCell === vendorCombination?.url ? (
                          <div className="d-flex align-items-center justify-content-center gap-1">
                            <input
                              type="number"
                              value={cellStockValue}
                              onChange={(e) => setCellStockValue(e.target.value)}
                              className="form-control form-control-sm text-gray-700"
                              style={{ width: '70px', textAlign: 'center' }}
                              min="0"
                              disabled={isUpdatingCellStock}
                              onWheel={(e) => e.target.blur()}
                            />
                            <button
                              className="btn btn-success btn-sm"
                              onClick={() => handleCellStockSave(vendorCombination)}
                              disabled={isUpdatingCellStock}
                              style={{ padding: '2px 6px', fontSize: '10px', minWidth: '24px', height: '24px' }}
                              title="Save"
                            >
                              <i className="bi bi-check" style={{ fontSize: '10px' }}></i>
                            </button>
                            <button
                              className="btn btn-secondary btn-sm"
                              onClick={handleCellStockCancel}
                              disabled={isUpdatingCellStock}
                              style={{ padding: '2px 6px', fontSize: '10px', minWidth: '24px', height: '24px' }}
                              title="Cancel"
                            >
                              <i className="bi bi-x" style={{ fontSize: '10px' }}></i>
                            </button>
                          </div>
                        ) : (
                          <div className="d-flex align-items-center justify-content-center gap-1">
                            <span className={`text-gray-700 fs-15 span-stock-33 ${Number(stock) > 1 ? 'bg-green-100' : 'bg-red-100'}`}>{stock || 0} units</span>
                            <img
                              src="/edit-icon.webp"
                              onClick={() => handleCellStockEdit(vendorCombination, stock || 0)}
                              className="pd_change_Price_pencil"
                              style={{ cursor: 'pointer', width: '14px', height: '14px' }}
                              alt="Edit stock"
                              title="Edit stock"
                            />
                          </div>
                        )}
                      </td>
                      <td style={{ padding: '12px', textAlign: 'center' }}>
                        <div className="d-flex align-items-center justify-content-center">
                          <div>
                            {pkgCount > 0 && vendorCombination?.sellerWeightChangeSts !== "T_REJECT" ? (
                              <>
                                <span
                                  className="bg-green-50 fs-15"
                                  style={{ cursor: 'pointer', padding: '4px 8px', borderRadius: '10px' }}
                                  onClick={() => handleWeightModalOpen(vendorCombination)}
                                >
                                  <i className="bi bi-box me-2" style={{ fontSize: '12px', color: '#666' }}></i>
                                  {pkgCount} box{pkgCount > 1 ? 'es' : ''} {
                                    (vendorCombination?.sellerWeightChangeSts === "V_ACTIVE" || vendorCombination?.sellerWeightChangeSts === "T_ACTIVE") ? <OverlayTrigger
                                      key="allord"
                                      placement="bottom"
                                      overlay={
                                        <Tooltip id={`tooltip-allord`} className="fs-10 order_page_tooltip">
                                          <p className='fs-12 f-500 order_page_tooltip_1'>Weight is locked.</p>
                                        </Tooltip>
                                      }
                                    >
                                      <i class="bi bi-info-circle ms-1"></i>
                                    </OverlayTrigger> : <></>
                                  }
                                </span>
                                <p className="text-danger text-center fs-10">{weightStatus}</p>
                              </>
                            ) : (
                              <>
                                <span
                                  className="bg-gray-100 fs-15"
                                  style={{ cursor: 'pointer', padding: '4px 8px', borderRadius: '10px' }}
                                  onClick={() => handleWeightModalOpen(vendorCombination)}
                                >
                                  <i className="bi bi-box me-2" style={{ fontSize: '12px', color: '#666' }}></i>
                                  Add
                                </span>
                                <p className="text-danger text-center fs-10">{weightStatus}</p>
                              </>
                            )}
                          </div>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}

                  <div className="bottom-border"></div>
        {/* Description */}
        <div className="pd_desc">
          <div
            className="d-flex align-items-center"
            style={{ cursor: 'pointer' }}
            onClick={() => setIsDescriptionCollapsed(!isDescriptionCollapsed)}
          >
            <i className="bi bi-file-text me-2" style={{ fontSize: '18px', color: '#339a99' }}></i>
            <h6 className="mb-0" style={{ color: '#333' }}>Description</h6>
            <i
              className={`bi ${isDescriptionCollapsed ? 'bi-chevron-right' : 'bi-chevron-down'} ms-auto`}
              style={{ fontSize: '16px', color: '#666' }}
            ></i>
          </div>
          {!isDescriptionCollapsed && pDetail && pDetail.description ? (
            <>
              <div
                className="pd_description"
                dangerouslySetInnerHTML={{
                  __html: pDetail.description,
                }}
              ></div>
              {pDetail?.descriptionNew && pDetail?.descriptionNew.map((item, index) => {
                return <><div class="title fs-13 mt-2 bold">{item?.title} : </div><div
                  className="desc fs-13"
                  dangerouslySetInnerHTML={{
                    __html: item.description,
                  }} />

                  {item?.title == 'Specification' && pDetail?.specificationNew && pDetail?.specificationNew.length > 0 &&
                    pDetail?.specificationNew && pDetail?.specificationNew.map((item, index) => {
                      return <><div
                        className="desc fs-14"
                      >
                        <ul><li>{item?.type?.name} : {item?.name}{" "}
                          {item?.unit}</li></ul>
                      </div></>
                    })
                  }
                </>
              })}
            </>
          ) : (
            <></>
          )}
          <div className="bottom-border"></div>
          {!(pDetail?.descriptionNew || []).some(obj => obj.title === "Specifications" || obj.title === "Specification") && pDetail?.specificationNew && pDetail?.specificationNew != "[]" && pDetail?.specificationNew.length > 0 && <>
            <div>
              <div
                className="d-flex align-items-center mt-2"
                style={{ cursor: 'pointer' }}
                onClick={() => setIsSpecificationCollapsed(!isSpecificationCollapsed)}
              >
                <i className="bi bi-list-ul me-2" style={{ fontSize: '18px', color: '#339a99' }}></i>
                <h6 className="mb-0" style={{ color: '#333' }}>Specifications</h6>
                <i
                  className={`bi ${isSpecificationCollapsed ? 'bi-chevron-right' : 'bi-chevron-down'} ms-auto`}
                  style={{ fontSize: '16px', color: '#666' }}
                ></i>
              </div>
              {!isSpecificationCollapsed && pDetail?.specificationNew && pDetail?.specificationNew != "[]" && pDetail?.specificationNew.map((item, index) => {
                return <><div
                  className="desc fs-14"
                >
                  <ul><li>{item?.type?.name} : {item?.name}{" "}
                    {item?.unit}</li></ul>
                </div></>
              })}
            </div></>}

          <div
            className="d-flex align-items-center"
            style={{ cursor: 'pointer' }}
            onClick={() => setIsShortDescriptionCollapsed(!isShortDescriptionCollapsed)}
          >
            <i className="bi bi-file-text-fill me-2" style={{ fontSize: '18px', color: '#339a99' }}></i>
            <h6 className="mb-0" style={{ color: '#333' }}>Short Description</h6>
            <i
              className={`bi ${isShortDescriptionCollapsed ? 'bi-chevron-right' : 'bi-chevron-down'} ms-auto`}
              style={{ fontSize: '16px', color: '#666' }}
            ></i>
          </div>
          {!isShortDescriptionCollapsed && (
            <div
              className="pd_description"
              dangerouslySetInnerHTML={{ __html: pDetail.shortDescription }}
            ></div>
          )}
          <div className="bottom-border"></div>
          <div
            className="d-flex align-items-center"
            style={{ cursor: 'pointer' }}
            onClick={() => setIsReviewsCollapsed(!isReviewsCollapsed)}
          >
            <i className="bi bi-star me-2" style={{ fontSize: '18px', color: '#339a99' }}></i>
            <h6 className="mb-0" style={{ color: '#333' }}>Product Reviews</h6>
            <i
              className={`bi ${isReviewsCollapsed ? 'bi-chevron-right' : 'bi-chevron-down'} ms-auto`}
              style={{ fontSize: '16px', color: '#666' }}
            ></i>
          </div>
          {!isReviewsCollapsed && (
            <div className="pd_description">
              <ProductReviews pId={props.match.params.pId} pDetail={pDetail} from="productDetails" />
            </div>
          )}


          {/* {!showMoreDetails ? (
              <p
                onClick={() => setshowMoreDetails(true)}
                className="pd_showMore_Details"
              >
                See more product details{" "}
                <i className="fa fa-chevron-right" aria-hidden="true"></i>
              </p>
            ) : (
              <p
                onClick={() => setshowMoreDetails(false)}
                className="pd_showMore_Details"
              >
                See fewer details{" "}
                <i className="fa fa-chevron-right" aria-hidden="true"></i>
              </p>
            )} */}
        </div>
      </div>
        </div>
      </div>

      <div className="d-flex justify-content-center" id="enNewLoader">
        <div
          className="spinner-border"
          role="status"
          style={{ display: ennewloader }}
        >
          <span className="sr-only"></span>
        </div>
      </div>

      <Modal
        show={confirmationShow}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Confirmation
          msg={msgConfirmation}
          onHide={() => setconfirmationShow(false)}
          responseconfirmation={responseconfirmationonly}
        />
      </Modal>

      <Modal
        show={confirmationState}
        size="lg"
        className="confirm_modal_det"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <ConfirmationModal
          onHide={confirmationBoxHiding}
          pId={pDetail.productName}
          selectedId={selectedId}
          msg={msgConfirmation}
          proresDeact={deactiveReason}
          responseconfirmationFun={responseconfirmation}
          buttonDesign={buttonDesign}
          from="productDetail"
        />
      </Modal>

      {/* Toast */}
      <Toast
        show={showToast}
        className="ToastHome"
        onClose={() => setshowToast(false)}
      >
        <Toast.Header>
          <strong className="me-auto">Message</strong>
        </Toast.Header>
        <Toast.Body>{ToastMsg}</Toast.Body>
      </Toast>

      {/* Off canvas for new price request */}

      <Offcanvas
        show={offcanshow}
        onHide={handleCloseoffcan}
        placement="bottom"
        className="h-60 pd_Offcanvas m-auto"
        backdrop="static"
      >
        <Offcanvas.Header>
          <Offcanvas.Title></Offcanvas.Title>
          <div className="w-100">
            <button
              className="pd_my_Modal_close_btn"
              onClick={() => handleCloseoffcan()}
            >
              X
            </button>
          </div>
        </Offcanvas.Header>
        <Offcanvas.Body className="m-0 p-0">
          <Container className="pd_offcanvas_body">
            <h4 className="text-center">
              {PriceReqType === "newCombReq"
                ? "Add Combination"
                : "New Price Request"}
            </h4>
            {PriceReqType === "newCombReq" ? (
              <></>
            ) : (
              <div className="pd_Offcanvas_Grey_Box">
                <p className="theme-col pb-1 pb-0 f-600 fs-14 row">
                  <i
                    className="fa fa-circle fs-11 col-1 m-auto pd_offcanvas_bullets"
                    aria-hidden="true"
                  ></i>
                  <span className="col-11 text-center">
                    <span className="text-black ">
                      Current Transfer Price (incl. {currGst}% GST){" "}
                    </span>
                    :
                    <span className="f-600 fs-13 ms-1 mt-1ff_pop">
                      <i className="fa fa-inr"></i>{" "}
                      {currcombarr && currcombarr.purchase_price}{" "}
                    </span>
                  </span>
                </p>
              </div>
            )}
            {lowestPrice !== undefined ? (
               <div className="pd_Offcanvas_Grey_Box">
                <p className="theme-col pb-1 pb-0 f-600 fs-14 row">
                  <i
                    className="fa fa-circle fs-11 col-1 m-auto pd_offcanvas_bullets"
                    aria-hidden="true"
                  ></i>
                  <span className="col-11 text-center">
                    <span className="pd_other_seller_price">
                      Other seller's price(incl. GST) {" "}
                    </span>
                    :
                    <span className="f-600 fs-13 ms-1 mt-1ff_pop">
                   <i className="fa fa-inr"></i> {lowestPrice}{" "}
                    </span>
                  </span>
                </p>
              </div>
            ) : (
              <></>
            )}

            <div className="pd_Offcanvas_Action">
              <div className="pd_Offcanvas_Grey_Box">
                <p className="iscorr_trans_p row">
                  <span className="col-7">
                    <i
                      className="fa fa-circle me-2 fs-11 pd_offcanvas_bullets"
                      aria-hidden="true"
                    ></i>{" "}
                    Please Enter New Transfer Price :
                  </span>
                  <i className="fa fa-inr pd_input_inr" aria-hidden="true"></i>
                  <input
                    className="pd_input_price col-2"
                    type="number"
                    onChange={(e) => checkenterprice(e.target.value)}
                    onWheel={(e) => e.target.blur()}
                  ></input>
                  <button
                    className="pd_change_gst_btn col-2"
                    id="sub_newreq"
                    onClick={() => newPriceReq()}
                  >
                    SUBMIT
                  </button>
                </p>
              </div>
              <div className="pd_Offcanvas_Grey_Box mt-1">
                <p className="row">
                  <span className="col-7 my-auto">
                    <i
                      className="fa fa-circle me-2 fs-11 pd_offcanvas_bullets"
                      aria-hidden="true"
                    ></i>{" "}
                    GST :{" "}
                  </span>
                  <Form.Select
                    size="sm"
                    className="pd_Gst_Options col-2"
                    value={gstPercent}
                    onChange={(e) => setGstPercent(e.target.value)}
                  >
                    {gstOptions.length > 0 &&
                      gstOptions.map((item, index) => {
                        return (
                          <option key={index} value={item}>
                            {item} %
                          </option>
                        );
                      })}
                  </Form.Select>{" "}
                  <button
                    className="pd_change_gst_btn col-2"
                    onClick={() => changeGSTFun()}
                  >
                    SUBMIT
                  </button>
                </p>
              </div>
            </div>
          </Container>
        </Offcanvas.Body>
      </Offcanvas>

      {/* Image showing modal */}

      <Modal
        show={imgmodalShow}
        onHide={imgmodalhandleClose}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header closeButton>
          {/* <Modal.Title>Modal title</Modal.Title> */}
        </Modal.Header>
        <Modal.Body>
          <Carousel className="carousel mod_caro m-4" pause="hover">
            {images.map((item, index) => {
              let baseImg;
              if (item.image.startsWith("products")) {
                baseImg = item.image;
              } else if (item.image.startsWith("mob")) {
                baseImg = item.image;
              } else {
                let img = item.image.substr("41");
                baseImg = img;
              }
              return (
                <Carousel.Item>
                  <img
                    className="d-block slide-size w-100"
                    src={"https://s3.toolsvilla.com/" + baseImg}
                    alt="Product Img"
                  />
                </Carousel.Item>
              );
            })}

            {/* Videos */}
            {videos.length > 0 &&
              images.length > 0 &&
              videos.map((item, index) => {
                let vidsrc;
                if (item.includes("products")) {
                  vidsrc = "https://media.toolsvilla.com/" + item;
                  return (
                    <Carousel.Item key={index} className="video">
                      <video
                        controls
                        className="d-block slide-size w-100"
                        src={vidsrc}
                        alt="Product Img"
                      />
                    </Carousel.Item>
                  );
                } else {
                  vidsrc = "https://www.youtube.com/embed/" + item;
                  return (
                    <Carousel.Item key={index} className="video">
                      <iframe
                        allowFullScreen
                        className="d-block slide-size w-100"
                        src={vidsrc}
                      ></iframe>
                    </Carousel.Item>
                  );
                }
              })}
          </Carousel>
        </Modal.Body>
      </Modal>

      {/* Off canvas for verify transfer price */}

      <Offcanvas
        show={offcanshowverify}
        onHide={handleCloseoffcanverify}
        placement="bottom"
        className="h-40 offcan_transfer_price"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title className="m-auto">
            Verify Transfer Price
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="m-0 p-0">
          {offcanstateverify === "ask" ? (
            <Container>
              <Card className=" mb-2 theme-outline  ">
                <p className="theme-col px-3 pt-2 pb-0 f-600 fs-14 curr_trans_p text-center">
                  Current Transfer Price (incl. {currGst}% GST) :
                  <span className="f-600 fs-13 ms-1 mt-1 text-black ff_pop">
                    {" "}
                    <i className="fa fa-inr"></i>{" "}
                    {currcombarr && currcombarr.purchase_price}{" "}
                  </span>
                </p>
                {lowestPrice !== undefined ? (
                  <p className="px-3 pt-2 pb-0 f-600 fs-11 text-center">
                    <span className="fs-17">
                      <i className="bi bi-exclamation-triangle-fill"></i>
                    </span>
                    <span className="other_seller_price">
                      {" "}
                      Other seller's price(incl. GST) :
                    </span>
                    <span className="f-600 fs-13 ms-1 mt-1 text-primary">
                      {" "}
                      <i className="fa fa-inr"></i> {lowestPrice}{" "}
                    </span>
                  </p>
                ) : (
                  <></>
                )}
                <p className="text-center fs-14 iscorr_trans_p">
                  Is this the correct price{" "}
                  <i class="fa fa-question" aria-hidden="true"></i>
                </p>

                <Row className="text-center my-3 ">
                  <div className="col-6 pt-1">
                    <button
                      className="yes-button1 offcan_yes_button"
                      onClick={() => yesVerifyPrice()}
                    >
                      Yes
                    </button>
                  </div>
                  <div className="col-6 pt-1">
                    <button
                      className="yes-button1 offcan_no_button"
                      onClick={() => noVerifyPrice()}
                    >
                      No
                    </button>
                  </div>
                </Row>
              </Card>
            </Container>
          ) : (
            <Container>
              <Card className=" mb-2 theme-outline  ">
                <p className="theme-col px-3 pt-2 pb-0 f-600 fs-14 curr_trans_p text-center">
                  Current Transfer Price (incl. {currGst}% GST) :
                  <span className="f-600 fs-13 ms-1 mt-1 text-black ff_pop">
                    {" "}
                    <i className="fa fa-inr"></i> {pPrice}{" "}
                  </span>
                </p>
                <p className="text-center fs-14 iscorr_trans_p">
                  Please Enter New Transfer Price (Incl.{" "}
                  <span className="ff_pop">{currGst}</span>% GST) :
                </p>
                <div className="text-center">
                  <i className="fa fa-inr me-2"></i>
                  <input
                    type="number"
                    onChange={(e) => setnewPrice(e.target.value)}
                    onWheel={(e) => e.target.blur()}
                    className="inr-input pl-1"
                  ></input>
                </div>
                <Row className="text-center my-3 ">
                  <div className="col-12 pt-1">
                    <button
                      className="yes-button1 ff_pop"
                      id="sub_newreq"
                      onClick={() => newPriceReq()}
                    >
                      Submit
                    </button>
                  </div>
                </Row>
              </Card>
            </Container>
          )}
        </Offcanvas.Body>
      </Offcanvas>

      {/* Off canvas for showing transfer price history */}
      <TPriceHistoryModal data={vendToolHistArr} show={offcanshowpriceHist}
        onHide={handleCloseoffcanpriceHist} />

      {/* New Price Offer Popup - SL-978 */}
      <NewPriceOfferPopup2
        show={showNewPriceOfferPopup}
        onHide={() => setShowNewPriceOfferPopup(false)}
        productData={newPriceOfferData}
        onYes={handleNewPriceOfferAccept}
        onNo={handleNewPriceOfferReject}
        onNewPriceSubmit={handleNewPriceOfferSubmit}
        acceptDisable = {acceptDisable}
        closeNotificationAndRefresh={closeNotificationAndRefresh}  // ✅ ADD THIS LINE
        from="product_detail_conf"
      />

      {/* Product report popup */}
      <div
        id="popupDetail"
        className="overlay"
        style={{ display: isDetailPopupVis, opacity: isDetailPopupVis ? 1 : 0, visibility: isDetailPopupVis ? "visible" : "hidden" }}
      >
        <PopupProductReport
          // description={rejectedProductsList[currdetailId].description}
          pid={selectedId}
          SKU={pDetail.SKU}
          product={pDetail}
          popupVisibility={setpopupVisibilityDetail}
          categories={pDetail?.categories}
        />
      </div>

      {/* HSN Modal */}
      <HSNModal
        show={showHSNModal}
        handleCloseModal={handleHSNModalClose}
        productData={{
          id: pDetail._id,
          productName: pDetail.productName,
          sku: pDetail.SKU,
          taxClass: pDetail.vendors?.[0]?.taxClass,
          HSN: pDetail.vendors?.[0]?.HSN
        }}
        from="Product Detail Conf"
        onSave={handleHSNSave}
      />

      {/* Weight Component Popup Modal */}
      <Modal
        show={showWeightModal}
        onHide={handleWeightModalClose}
        backdrop="static"
        keyboard={false}
        size="lg"
        centered
        style={{ width: '80vw' }}
        dialogClassName="weight-modal-dialog"
        className="modal-prodDetConf-Weight"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <i className="bi bi-box me-2" style={{ color: '#339a99' }}></i>
            Add Package Details - {selectedCombinationForWeight ?
              pDetail.combination.find(comb => comb.url === selectedCombinationForWeight.url)?.value.join(' / ') || 'Configuration'
              : 'Configuration'
            }
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedCombinationForWeight && (
            <>
              {/* Weight acceptance status and note */}
              {selectedCombinationForWeight?.sellerWeightChangeSts === "T_REJECT" ? (
                <div className="alert alert-danger mb-3">
                  <span className="text-danger">The dimension request has been rejected. Please update again.
                      {selectedCombinationForWeight?.sellerWeightRejectionReason ?<OverlayTrigger
                        key="transfer"
                        placement="bottom"
                        overlay={
                          <Tooltip id={`tooltip-transfer`} className="fs-10 order_page_tooltip">
                            <p className='fs-11 f-500 order_page_tooltip_1'>{selectedCombinationForWeight.sellerWeightRejectionReason}</p>
                          </Tooltip>
                        }
                      >
                        <i className="bi bi-info-circle ml-1 ms-1"></i>
                      </OverlayTrigger>
                    : <></> }
                  </span>
                </div>
              ) : null}

              <WeightComponent
                handleSubmit={handlePackageSubmission}
                isUpdated={isPackageUpdated}
                viewOnly={packageViewOnly}
                curComArr={selectedCombinationForWeight}
                weightRequest={isWeightRequest}
                handleAcceptPackage={updateSellerWeightChangeSts}
                weightChangeStatus={selectedCombinationForWeight?.sellerWeightChangeSts}
                proceed={async () => {
                  await handlePackageSubmission();
                  handleWeightModalClose();
                }}
              />
              {selectedCombinationForWeight?.lockStatus && (selectedCombinationForWeight?.sellerWeightChangeSts === "V_ACTIVE" || selectedCombinationForWeight?.sellerWeightChangeSts === "T_ACTIVE") && (
                <div className="mb-3 fs-14">
                  <span>
                    This Sku's weight details are accepted by {selectedCombinationForWeight?.sellerWeightChangeSts === "V_ACTIVE" ? "you" : "Toolsvilla"} on {toLocalDateTime(selectedCombinationForWeight?.sellerWeightChangeDate)}
                    <OverlayTrigger
                      key="transfer"
                      placement="bottom"
                      overlay={
                        <Tooltip id={`tooltip-transfer`} className="fs-10 order_page_tooltip">
                          <p className='fs-8 f-500 order_page_tooltip_1'>{variables.detailsLockedWeight}</p>
                        </Tooltip>
                      }
                    >
                      <i className="bi bi-info-circle ms-1"></i>
                    </OverlayTrigger>
                  </span>
                </div>
              )}
              {selectedCombinationForWeight?.sellerWeightChangeSts &&
                <button className="package_history_btn" onClick={() => setPkgHistoryModalShow(true)}>Check history</button>
              }
              {selectedCombinationForWeight?.sellerWeightChangeSts === "V_PENDING" ||
                selectedCombinationForWeight?.sellerWeightChangeSts === "V_ACTIVE" ? (
                <div className="mb-3">
                  <p className="mb-2 fs-12">
                    <strong>Note -</strong> All the shipments are checked at our courier
                    warehouse and if in case the product weight & dimensions
                    are found different than that given by the logistics
                    company Toolsvilla would debit the seller for the
                    difference. We therefore request you to be careful when
                    entering the weight & dimensions. Thank you!
                  </p>
                </div>
              ) : null}


            </>
          )}
        </Modal.Body>
      </Modal>

      {/* l1-2553 */}
      <PackageHistoryModal
        onHide={() => setPkgHistoryModalShow(false)}
        show={pkgHistoryModalShow}
        productId={selectedId}
        url={selectedCombinationForWeight ? selectedCombinationForWeight.url : null}
      />
    </div>

  );
}
export default ProductDetConf;